"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageReporting = void 0;
const endOfToday_1 = __importDefault(require("date-fns/endOfToday"));
const startOfToday_1 = __importDefault(require("date-fns/startOfToday"));
const firestore_1 = require("firebase/firestore");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const OverlayTrigger_1 = __importDefault(require("react-bootstrap/OverlayTrigger"));
const Tooltip_1 = __importDefault(require("react-bootstrap/Tooltip"));
// @ts-ignore
const react_html_table_to_excel_1 = __importDefault(require("react-html-table-to-excel"));
const configContext_1 = require("../../context/configContext");
const BookingStatus_1 = require("../../models/BookingStatus");
const bookingFactory = __importStar(require("../../models/helper/bookingFactory"));
const dateUtils = __importStar(require("../../utils/dateUtils"));
const useFirestore_1 = require("../../utils/useFirestore");
const useQueryString_1 = require("../../utils/useQueryString");
const BookingFilters_1 = require("../booking-filters/BookingFilters");
const IconHelpOutline_1 = require("../icons/IconHelpOutline");
const ManagerReportingTable_1 = require("../manager-tables/ManagerReportingTable");
const Spinner_1 = require("../spinner/Spinner");
const ManagerPageReporting = (props) => {
    const [bookings, setBookings] = (0, react_1.useState)([]);
    const [filteredBookings, setFilteredBookings] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    const [viewFilter, setViewFilter] = (0, useQueryString_1.useQueryStringForString)("view", "week", (value) => ["day", "week", "month", "year"].includes(value));
    const [dateFilter, setDateFilter] = (0, useQueryString_1.useQueryStringForDate)("date", (0, startOfToday_1.default)());
    const [resourcesFilter, setResourcesFilter] = (0, useQueryString_1.useQueryStringForStringArray)("resources", config.resources.map((r) => r.id), "comma");
    const [showOutstandingBalanceByPeriod, setShowOutstandingBalanceByPeriod] = (0, useQueryString_1.useQueryStringForBoolean)("outstandingBalanceByPeriod", false);
    const [fromDate, toDate] = dateUtils.getViewRange(viewFilter, dateFilter);
    /** Load bookings whenever filters change. */
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        const unsubscribeQuery = (0, firestore_1.onSnapshot)((0, firestore_1.query)((0, firestore_1.collection)(firestore, "bookings"), (0, firestore_1.where)("tenantId", "==", config.tenantId), (0, firestore_1.where)("start", ">=", fromDate), (0, firestore_1.where)("start", "<=", toDate), (0, firestore_1.where)("status", "in", BookingStatus_1.BookingStatus.allCustomerBookingStatus.map((s) => s.name))), (querySnapshot) => {
            const bookings = bookingFactory.createAllFromFirestore(querySnapshot.docs, config);
            setBookings(bookings);
            setIsLoading(false);
        }, (err) => {
            console.error(err);
        });
        return () => unsubscribeQuery();
    }, [viewFilter, dateFilter]);
    // Filter bookings by resource (on client).
    (0, react_1.useEffect)(() => {
        setFilteredBookings(bookings.filter((booking) => {
            // Filter Resource.
            if (!resourcesFilter.find((resourceId) => resourceId === booking.getResourceId())) {
                return false;
            }
            return true;
        }));
    }, [bookings, resourcesFilter]);
    let content;
    if (isLoading) {
        content = react_1.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" });
    }
    else if (filteredBookings) {
        content = (react_1.default.createElement(ManagerReportingTable_1.ManagerReportingTable, { bookings: filteredBookings, paidByDate: showOutstandingBalanceByPeriod ? toDate : (0, endOfToday_1.default)() }));
    }
    else {
        content = "Fehler beim Laden der Buchungen. Bitte Support kontaktieren.";
    }
    return (react_1.default.createElement(Container_1.default, { fluid: true, className: "manager-page-reporting main-content d-flex flex-column" },
        react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between mt-4" },
            react_1.default.createElement("h1", { className: "text-nowrap mb-0" },
                "Auswertung",
                react_1.default.createElement(OverlayTrigger_1.default, { placement: "right", overlay: react_1.default.createElement(Tooltip_1.default, { id: "title-tooltip" }, "F\u00FCr Buchhaltung und Gwundernasen.") },
                    react_1.default.createElement("span", { className: "text-secondary pl-1 no-print", style: { fontSize: "20px" } },
                        react_1.default.createElement(IconHelpOutline_1.IconHelpOutline, null)))),
            react_1.default.createElement("div", { className: "d-flex" },
                react_1.default.createElement(react_bootstrap_1.Form.Check, { className: "mt-2 mr-3", type: "switch", label: "Offener Betrag auf Periode eingrenzen", id: "show-outstanding-balance-by-period-switch", checked: showOutstandingBalanceByPeriod, onChange: (e) => setShowOutstandingBalanceByPeriod(e.target.checked) }),
                react_1.default.createElement(react_html_table_to_excel_1.default, { className: "btn btn-success", table: "table", filename: dateUtils.formatDateIso(fromDate) + " Reporting - Benjibooks", sheet: "sheet", buttonText: "Excel Export" }))),
        react_1.default.createElement(BookingFilters_1.BookingFilters, { className: "mt-4", view: viewFilter, onViewChange: setViewFilter, viewButtons: ["day", "week", "month", "year"], date: dateFilter, onDateChange: setDateFilter, resources: resourcesFilter, onResourcesChange: setResourcesFilter, minDate: dateUtils.defaultMinDate, maxDate: dateUtils.defaultMaxDate }),
        content));
};
exports.ManagerPageReporting = ManagerPageReporting;
